<template>
  <el-dialog title="修改密码" :visible.sync="visible" width="400px" :append-to-body="true">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px" size="small">
      <el-form-item label="账号">
        <span>{{ currentUser.account }}</span>
      </el-form-item>
      <el-form-item label="原密码" prop="password">
        <el-input type="password" v-model="dataForm.password" show-password></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" v-model="dataForm.newPassword" show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input type="password" v-model="dataForm.confirmPassword"  show-password></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { clearLoginInfo } from '@/utils'
import Encrypt from '@/utils/encrypt'
export default {
  data () {
    let validateConfirmPassword = (rule, value, callback) => {
      if (this.dataForm.newPassword !== value) {
        callback(new Error('确认密码与新密码不一致'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      dataForm: {
        id: '',
        account: '',
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      dataRule: {
        password: [
          { required: true, message: '原密码不能为空', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '新密码不能为空', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    currentUser: {
      get () {
        return this.$store.state.user.currentUser
      }
    },
    mainTabs: {
      get () {
        return this.$store.state.common.mainTabs
      },
      set (val) {
        this.$store.commit('common/updateMainTabs', val)
      }
    }
  },
  methods: {
    // 初始化
    init () {
      this.dataForm.id = this.currentUser.id
      this.dataForm.account = this.currentUser.account
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.dataForm))
          // 检查
          if (params.password == params.confirmPassword) {
            this.$message.error('新旧密码一致')
            return
          }
          params.password = Encrypt.RSAEncrypt(params.password)
          params.newPassword = Encrypt.RSAEncrypt(params.newPassword)
          params.confirmPassword = Encrypt.RSAEncrypt(params.confirmPassword)
          this.$http({
            url: this.$http.adornUrl('/system/user/password'),
            method: 'post',
            data: this.$http.adornData(params)
          }).then(({ data }) => {
            if (data) {
              this.$message({
                message: '修改成功,请使用新密码登录',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$nextTick(() => {
                    this.mainTabs = []
                    // 执行退出
                    this.logoutHandle()
                  })
                }
              })
            } else {
              this.$message.error('修改失败')
            }
          })
        }
      })
    },
    // 退出
    logoutHandle () {
      this.$http({
        url: this.$http.adornUrl('/auth/logout'),
        method: 'delete',
        data: this.$http.adornData()
      }).then(({ data }) => {
        clearLoginInfo()
        this.$router.push({ name: 'login' })
      })
    }
  }
}
</script>
